<template>
  <div>
    <div class="w-full h-full fixed top-0 left-0 -z-10 bg-[#e5e7eb]"></div>
    <Header />
    <div class="bg-[#18469d] p-5 text-white font-bold">
      <ul class="breadcrumb flex">
        <li
          v-for="(item, index) in b_value"
          :key="index"
          :class="{
            'breadcrumb-item': !isActive(index),
            'active-breadcrumb-item': isActive(index),
          }"
        >
          <span class="pl-2" :class="{ 'breadcrumb-text': !isActive(index) }">
            <a :href="item.link">{{ item.text }}</a>
          </span>
          <span v-if="index < b_value.length - 1" class="breadcrumb-arrow">
            >
          </span>
        </li>
      </ul>
    </div>
    <div class="p-5 lg:p-10">
      <div class="w-full h-full py-5 flex flex-col gap-5">
        <h1 class="text-lg lg:text-2xl font-semibold dark_text">
          Attendance List
        </h1>

        <div class="w-full flex justify-end items-center">
          <router-link :to="{ name: 'StudentCalender' }">
            <button
              class="attendance_btn px-4 py-2 rounded-lg uppercase text-xs font-semibold"
            >
              view all
            </button>
          </router-link>
        </div>
        <div class="w-full overflow-scroll">
          <table class="min-w-full">
            <thead>
              <tr class="text-left bg-[#18469d] text whitespace-nowrap text-sm">
                <th class="px-6 py-3">S.No</th>
                <th class="px-6 py-3">Course</th>
                <th class="px-6 py-3">Subject Name</th>
                <th class="px-6 py-3">Subject Code</th>
                <th class="px-6 py-3">Taken</th>
                <th class="px-6 py-3">Present</th>
                <th class="px-6 py-3">Absent</th>
                <th class="px-6 py-3">Attendance%</th>
              </tr>
            </thead>
            <tbody v-if="loading" class="bg-[#e5e7eb] w-fit">
              <tr class="w-full">
                <td colspan="12" class="text-center py-6">
                  <div class="flex items-center justify-center">
                    <img src="@/assets/attendance/loading.gif" alt="" />
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <template v-if="attendance_list.length > 0">
                <tr
                  v-for="(list, index) in attendance_list"
                  :key="index"
                  class="border-b border-[#afdaec] text-left whitespace-nowrap text-sm"
                >
                  <td class="px-6 py-3">{{ index + 1 }}</td>
                  <td class="px-6 py-3">{{ list.course }}</td>
                  <td class="px-6 py-3">
                    {{ list.subject_name }}
                  </td>
                  <td class="px-6 py-3">{{ list.subject_code }}</td>
                  <td class="px-6 py-3">{{ list.class_taken }}</td>
                  <td class="px-6 py-3">{{ list.class_present }}</td>
                  <td class="px-6 py-3">{{ list.class_absent }}</td>
                  <td class="px-6 py-3">{{ list.attendance_percentage }}</td>
                </tr>
              </template>
              <tr v-else>
                <td colspan="11" class="px-6 py-3 text-center">
                  No Data Found
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="11" class="p-6 bg-[#18469d]"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Student/Header.vue";
import axios from "axios";
export default {
  data() {
    return {
      attendance_list: [],

      b_value: [],
      loading: true,
    };
  },
  components: {
    Header,
  },
  async created() {
    this.b_value = [
      { text: "Skool Lms", link: "/" },
      { text: "AttendanceList", link: "" },
    ];
    await this.getstudentlist();
  },
  methods: {
    isActive(index) {
      return index === this.b_value.length - 1;
    },
    getstudentlist() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_COMS
          }/student/attendance/list/?Key=${localStorage.getItem("LmsId")}`
        )
        .then((resp) => {
          console.log("resp", resp);
          if (resp.data.status == 200) {
            this.attendance_list = resp.data.data;
            setTimeout(() => {
              this.loading = false;
            }, 600);
          }
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 600);
        });
    },
  },
};
</script>

<style></style>
